import React from "react";
import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy routes redirect to the unified Newsletter page (Editor tab).
 */
const NewsletterEditorPage = () => {
  const { documentId } = useParams();
  const params = new URLSearchParams({ tab: "editor" });
  if (documentId) {
    params.set("documentId", decodeURIComponent(documentId));
  }
  return <Navigate to={`/newsletter?${params.toString()}`} replace />;
};

export default NewsletterEditorPage;
 